<template>
  <div class="contract-summary-document">
    <p>Bestandteil Ihres Vertrages ist außerdem die Vertragszusammenfassung.</p>
    <p>Die Vertragszusammenfassung finden Sie <span class="link" @click="download">hier</span>.</p>

    <slot name="txtAfter"></slot>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ContractSummaryDocument',
  computed: {
    ...mapGetters('activation/submit', [
      'contractDocumentUrl'
    ]
    )
  },
  methods: {
    ...mapActions('activation/submit', [
      'activationInitiate'
    ]),
    download () {
      const baseUrl = this.$config.apiUrl
      if (this.contractDocumentUrl) {
        this.isAgreement = true
        window.open(
              `${baseUrl}${this.contractDocumentUrl}`
        )
      }
    }
  }
}
</script>
